var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : new P(function (resolve) { resolve(result.value); }).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { EventEmitter, OnChanges, OnDestroy, OnInit, SimpleChanges, } from '@angular/core';
import { ClrForm } from '@clr/angular';
import { FormControl, FormGroup } from 'ngx-strongly-typed-forms';
import { ApiRoutePlurality, HTTP_METHOD, ProjectMemberType } from '../../../../../defs/schema-static';
import { EMPLOYEE_FIELD, EMPLOYEE_SCHEMA_ROUTE } from '../../../../../defs/schema/public/Employees';
import { PROJECT_MEMBER_FIELD, PROJECT_MEMBER_SCHEMA_ROUTE, } from '../../../../../defs/schema/public/ProjectMembers';
import { USER_FIELD } from '../../../../../defs/schema/public/Users';
import { PROJECT_MEMBER_SORT_FUNCTION } from '../../../../../defs/sorters';
import { AuthService } from '../../auth/auth.service';
import { requiredProjectMembers } from '../../forms/validators/required-project-members.validator';
import { EMPLOYEE_MEMBER_TYPE } from '../../shared/editable-employee-label/editable-employee-label.component';
import { HttpRestService } from '../../shared/http-rest/http-rest.service';
var PROJECT_MEMBERS_FORM_KEYS;
(function (PROJECT_MEMBERS_FORM_KEYS) {
    PROJECT_MEMBERS_FORM_KEYS["members"] = "members";
})(PROJECT_MEMBERS_FORM_KEYS || (PROJECT_MEMBERS_FORM_KEYS = {}));
var CONFIRM_ACTION;
(function (CONFIRM_ACTION) {
    CONFIRM_ACTION["DOWNGRADE"] = "DOWNGRADE";
    CONFIRM_ACTION["DELETE"] = "DELETE";
})(CONFIRM_ACTION || (CONFIRM_ACTION = {}));
var ProjectWizardProjectMembersComponent = (function () {
    function ProjectWizardProjectMembersComponent(httpRest, authService) {
        var _a;
        this.httpRest = httpRest;
        this.authService = authService;
        this.form = new FormGroup((_a = {},
            _a[PROJECT_MEMBERS_FORM_KEYS.members] = new FormControl(null, requiredProjectMembers()),
            _a));
        this.employees = [];
        this.membersChange = new EventEmitter();
        this.autoSubmit = false;
        this.disabled = false;
        this.memberList = [];
        this.showConfirmSudokuModal = false;
        this.PROJECT_MEMBERS_FORM_KEYS = PROJECT_MEMBERS_FORM_KEYS;
        this.PROJECT_MEMBER_FIELD = PROJECT_MEMBER_FIELD;
        this.EMPLOYEE_MEMBER_TYPE = EMPLOYEE_MEMBER_TYPE;
        this.EMPLOYEE_FIELD = EMPLOYEE_FIELD;
        this.USER_FIELD = USER_FIELD;
    }
    ProjectWizardProjectMembersComponent.prototype.ngOnInit = function () {
        var _this = this;
        if (!this.employees || !this.employees.length) {
            (function () { return __awaiter(_this, void 0, void 0, function () { return __generator(this, function (_a) {
                return [2, this.getEmployees()];
            }); }); })();
            return;
        }
        this.setMembers();
        this.setMemberList();
        if (this.disabled) {
            this.form.controls[PROJECT_MEMBERS_FORM_KEYS.members].disable();
        }
    };
    ProjectWizardProjectMembersComponent.prototype.ngOnChanges = function (changes) {
        if (changes.members) {
            this.setMembers();
        }
        if (changes.members || changes.employees) {
            this.setMemberList();
        }
        if (changes.disabled) {
            var control = this.form.controls[PROJECT_MEMBERS_FORM_KEYS.members];
            this.disabled ? control.disable() : control.enable();
        }
    };
    ProjectWizardProjectMembersComponent.prototype.ngOnDestroy = function () {
        this.form.reset();
    };
    ProjectWizardProjectMembersComponent.prototype.getEmployees = function () {
        return __awaiter(this, void 0, void 0, function () {
            var _a;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        _a = this;
                        return [4, this.httpRest
                                ._request(HTTP_METHOD.GET, ApiRoutePlurality.PLURAL, EMPLOYEE_SCHEMA_ROUTE, 'project')
                                .toPromise()];
                    case 1:
                        _a.employees = (_b.sent()).sort(function (e1, e2) { return e1.user.name.localeCompare(e2.user.name); });
                        this.setMemberList();
                        return [2];
                }
            });
        });
    };
    ProjectWizardProjectMembersComponent.prototype.setMembers = function () {
        this.form.patchValue({
            members: this.members,
        });
    };
    ProjectWizardProjectMembersComponent.prototype.setMemberList = function () {
        var existingEmployeeIds = (this.members || []).map(function (_a) {
            var employee = _a.employee;
            return employee.id;
        });
        this.memberList = (this.members || []).concat(this.employees
            .filter(function (employee) { return !existingEmployeeIds.includes(employee.id); })
            .map(function (employee) {
            return ({
                employee: employee,
                employeeId: employee.id,
            });
        }));
    };
    ProjectWizardProjectMembersComponent.prototype.emitChanges = function () {
        this.membersChange.emit((this.members = this.form.value.members));
    };
    ProjectWizardProjectMembersComponent.prototype.addMember = function (member) {
        return __awaiter(this, void 0, void 0, function () {
            var _member;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (!this.autoSubmit) return [3, 2];
                        return [4, this.httpRest
                                .put(PROJECT_MEMBER_SCHEMA_ROUTE, {
                                projectId: this.project.id,
                                type: member.type || ProjectMemberType.MEMBER,
                                employeeId: member.employee.id,
                            })
                                .toPromise()];
                    case 1:
                        _member = _a.sent();
                        member.id = _member.id;
                        _a.label = 2;
                    case 2:
                        this.emitChanges();
                        return [2];
                }
            });
        });
    };
    ProjectWizardProjectMembersComponent.prototype.updateMember = function (member, force) {
        if (force === void 0) { force = false; }
        return __awaiter(this, void 0, void 0, function () {
            var members;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (!force &&
                            member.employeeId === this.authService.user.employee.id &&
                            member.type !== ProjectMemberType.MANAGER) {
                            this.confirmMember = member;
                            this.confirmAction = CONFIRM_ACTION.DOWNGRADE;
                            this.showConfirmSudokuModal = true;
                            return [2];
                        }
                        members = this.form.value.members;
                        this.form.patchValue({ members: members });
                        if (!this.autoSubmit) return [3, 2];
                        return [4, this.httpRest
                                .post(PROJECT_MEMBER_SCHEMA_ROUTE, {
                                id: member.id,
                                type: member.type || ProjectMemberType.MEMBER,
                            })
                                .toPromise()];
                    case 1:
                        _a.sent();
                        _a.label = 2;
                    case 2:
                        this.emitChanges();
                        return [2];
                }
            });
        });
    };
    ProjectWizardProjectMembersComponent.prototype.removeMember = function (member, force) {
        if (force === void 0) { force = false; }
        return __awaiter(this, void 0, void 0, function () {
            var members;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (!force &&
                            member.employeeId === this.authService.user.employee.id &&
                            member.type === ProjectMemberType.MANAGER) {
                            this.confirmMember = member;
                            this.confirmAction = CONFIRM_ACTION.DELETE;
                            this.showConfirmSudokuModal = true;
                            return [2];
                        }
                        members = this.form.value.members;
                        members.splice(members.indexOf(member), 1);
                        this.form.patchValue({ members: members });
                        if (!this.autoSubmit) return [3, 2];
                        return [4, this.httpRest
                                .deleteQuery(PROJECT_MEMBER_SCHEMA_ROUTE, {
                                projectId: this.project.id,
                                employeeId: member.employee.id,
                            })
                                .toPromise()];
                    case 1:
                        _a.sent();
                        _a.label = 2;
                    case 2:
                        this.emitChanges();
                        return [2];
                }
            });
        });
    };
    ProjectWizardProjectMembersComponent.prototype.submit = function () {
        return __awaiter(this, void 0, void 0, function () {
            var members, projectMembers;
            var _this = this;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (!this.project || !this.project.id) {
                            throw new Error("missing project id, can't submit ");
                        }
                        if (!this.form.valid) {
                            this.clrForm.markAsDirty();
                            return [2, undefined];
                        }
                        members = this.form.value.members;
                        return [4, this.httpRest
                                .putEntities(PROJECT_MEMBER_SCHEMA_ROUTE, members.map(function (member) { return ({
                                projectId: _this.project.id,
                                type: member.type || ProjectMemberType.MEMBER,
                                employeeId: member.employee.id,
                            }); }))
                                .toPromise()];
                    case 1:
                        projectMembers = _a.sent();
                        this.emitChanges();
                        return [2, projectMembers
                                .map(function (member) { return (__assign({}, member, { employee: _this.employees.find(function (_a) {
                                    var id = _a.id;
                                    return id === member.employeeId;
                                }) })); })
                                .sort(PROJECT_MEMBER_SORT_FUNCTION)];
                }
            });
        });
    };
    ProjectWizardProjectMembersComponent.prototype.closeSudokuModal = function () {
        this.confirmMember = undefined;
        this.showConfirmSudokuModal = false;
        this.confirmAction = undefined;
    };
    ProjectWizardProjectMembersComponent.prototype.cancelSudoku = function () {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (this.confirmAction) {
                    case CONFIRM_ACTION.DOWNGRADE:
                        this.confirmMember.type = ProjectMemberType.MANAGER;
                        break;
                    case CONFIRM_ACTION.DELETE:
                        break;
                    default:
                        throw new Error("unknown action: " + this.confirmAction);
                }
                this.closeSudokuModal();
                return [2];
            });
        });
    };
    ProjectWizardProjectMembersComponent.prototype.confirmSudoku = function () {
        return __awaiter(this, void 0, void 0, function () {
            var _a;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        _a = this.confirmAction;
                        switch (_a) {
                            case CONFIRM_ACTION.DOWNGRADE: return [3, 1];
                            case CONFIRM_ACTION.DELETE: return [3, 3];
                        }
                        return [3, 5];
                    case 1: return [4, this.updateMember(this.confirmMember, true)];
                    case 2:
                        _b.sent();
                        return [3, 6];
                    case 3: return [4, this.removeMember(this.confirmMember, true)];
                    case 4:
                        _b.sent();
                        return [3, 6];
                    case 5: throw new Error("unknown action: " + this.confirmAction);
                    case 6:
                        this.closeSudokuModal();
                        return [2];
                }
            });
        });
    };
    return ProjectWizardProjectMembersComponent;
}());
export { ProjectWizardProjectMembersComponent };
